import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { rupiah } from "@/lib/format";
import { PageHeader } from "@/components/app/Layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ArusKas() {
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [d, setD] = useState(null);
  useEffect(()=>{ api.get("/laporan/arus-kas",{params:{tahun}}).then(r=>setD(r.data)); },[tahun]);
  if(!d) return null;
  return (<>
    <PageHeader title="Laporan Arus Kas" subtitle={`Tahun ${tahun}`}/>
    <div className="p-4 md:p-8 space-y-6">
      <div className="card-flat p-4 max-w-xs"><Label>Tahun</Label><Input type="number" value={tahun} onChange={(e)=>setTahun(Number(e.target.value)||tahun)}/></div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <div className="card-flat p-5"><div className="text-[11px] uppercase tracking-widest text-slate-500">Total Kas Masuk</div><div className="mt-2 font-mono text-2xl text-emerald-700">{rupiah(d.total_masuk)}</div></div>
        <div className="card-flat p-5"><div className="text-[11px] uppercase tracking-widest text-slate-500">Total Kas Keluar</div><div className="mt-2 font-mono text-2xl text-rose-700">{rupiah(d.total_keluar)}</div></div>
        <div className="card-flat p-5"><div className="text-[11px] uppercase tracking-widest text-slate-500">Saldo Akhir</div><div className="mt-2 font-mono text-2xl brand-text">{rupiah(d.saldo_akhir)}</div></div>
      </div>
      <div className="card-flat overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50 border-b text-left text-[11px] uppercase text-slate-500"><th className="p-3">Bulan</th><th className="p-3 text-right">Kas Masuk</th><th className="p-3 text-right">Kas Keluar</th><th className="p-3 text-right">Arus Bersih</th><th className="p-3 text-right">Saldo Akhir</th></tr></thead>
          <tbody>
            {d.rincian.length===0 && <tr><td colSpan="5" className="text-center py-10 text-slate-400">Belum ada data.</td></tr>}
            {d.rincian.map(r=>(<tr key={r.bulan_key} className="border-b"><td className="p-3">{r.bulan}</td><td className="p-3 text-right font-mono text-emerald-700">{rupiah(r.kas_masuk)}</td><td className="p-3 text-right font-mono text-rose-700">{rupiah(r.kas_keluar)}</td><td className={`p-3 text-right font-mono ${r.arus_bersih>=0?"text-emerald-700":"text-rose-700"}`}>{rupiah(r.arus_bersih)}</td><td className="p-3 text-right font-mono font-semibold">{rupiah(r.saldo_akhir)}</td></tr>))}
          </tbody>
        </table>
      </div>
    </div>
  </>);
}
